import { createContext, ReactNode, useContext } from "react";

const DropoffTrackingContext = createContext(false);

/**
 * Wraps every route mounted under the `/d/` prefix (see `SandboxApp`) so
 * any page in that subtree can read "is this a dropoff-specific tracking
 * link" via `useIsDropoffTracking` without re-deriving it from the URL
 * itself. Mirrors the legacy `state.order.isDropoffTracking` flag, which
 * was likewise resolved once — from which route matched — and read
 * everywhere downstream (status text, ETA gating, dropoff visibility, ...).
 */
export const DropoffTrackingProvider = ({ children }: { children: ReactNode }) => (
  <DropoffTrackingContext.Provider value={true}>{children}</DropoffTrackingContext.Provider>
);

/** Defaults to `false` outside a `DropoffTrackingProvider` — the standard
 * tracking flow, no provider required. */
export function useIsDropoffTracking(): boolean {
  return useContext(DropoffTrackingContext);
}
